module.exports = __webpack_public_path__ + "static/media/P24.4a09954c.svg";